import React from 'react';
import { Clock, Award, Shield, DollarSign, Package, Heart } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import FadeInOnScroll from './FadeInOnScroll';

const reasons = [
  {
    icon: Clock,
    title: 'Fast Turnaround',
    description: 'Most repairs completed same-day or within 24 hours'
  },
  {
    icon: Award,
    title: 'Expert Technicians',
    description: 'OEM certified professionals with years of experience'
  },
  {
    icon: Shield,
    title: 'Warranty',
    description: 'Industry-leading warranty on all repairs and parts'
  },
  {
    icon: DollarSign,
    title: 'Fair Pricing',
    description: 'Competitive rates with no hidden fees'
  },
  {
    icon: Package,
    title: 'Genuine Parts',
    description: 'Genuine OEM and High-Quality parts used'
  },
  {
    icon: Heart,
    title: 'Top-Notch Service',
    description: 'Exceptional customer care every time'
  }
];

const WhyChooseSection = () => {
  return (
    <section className="py-20 px-6 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef9f9 100%)' }}>
      <div
        aria-hidden="true"
        className="absolute -bottom-32 -left-32 w-[28rem] h-[28rem] rounded-full opacity-[0.08]"
        style={{ background: 'radial-gradient(circle, #00B3B3 0%, transparent 70%)' }}
      />

      <div className="max-w-7xl mx-auto relative">
        <FadeInOnScroll className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Choose Nexera?</h2>
          <div className="w-24 h-1 mx-auto" style={{ backgroundColor: '#00B3B3' }} />
        </FadeInOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <FadeInOnScroll key={index} delay={index * 90}>
              <Card className="glass-card border-0 group h-full">
                <CardContent className="p-8 text-center">
                  <div
                    className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-6 group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-300"
                    style={{
                      background: 'linear-gradient(135deg, #00B3B3 0%, #14e3e3 100%)',
                      boxShadow: '0 10px 30px -10px rgba(0, 179, 179, 0.6)',
                    }}
                  >
                    <reason.icon className="w-10 h-10 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{reason.description}</p>
                </CardContent>
              </Card>
            </FadeInOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;